import MajorBannerDisplay from './MajorBannerDisplay'
export default MajorBannerDisplay;